import script from "./DropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDown.vue?vue&type=script&setup=true&lang=js"

import "./DropDown.vue?vue&type=style&index=0&id=3f8fb187&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8fb187"]])

export default __exports__